import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z" /></g>,<defs key="1"></defs>,]
, 'ActionRemoveCircleFilledx');
